<div class="p-4 overflow-auto h-[85vh]">

    <div class="flex justify-between -mt-4">
      <h2 class="text-xl font-semibold">Organization Package</h2>
      <p-button icon="pi pi-plus" 
      *ngIf="organizationPackage?.length < 1 && !loading"
      label="Add Package" (click)="openAddModal()" class="mb-3"></p-button>
    </div>
  
    <p-table [value]="organizationPackage" [rows]="rows" [totalRecords]="totalRecords"  [loading]="loading">
  
      <ng-template pTemplate="header">
        <tr>
          <th>Package ID</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Total User Limit</th>
          <th>Status</th>
          <th>Reminder Before Date</th>
          <th> Grace Period</th>
          <th>Action</th>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-package >

        <tr>
          <td>{{package.package_id}}</td>
          <td>{{package.start_date | date:'dd/MM/yyyy'}}</td>
          <td>{{package.end_date | date:'dd/MM/yyyy'}}</td>
          <td>{{package.total_user}}</td>
          <td>
           {{package.status}}
          </td>
          <td>{{package.reminder_before_days}}</td>
          <td>{{package.grace_period}}</td>
          <td>
            <div (click)="setOrgData(package)">
              <p-menu [tabindex]="undefined" #menu [model]="orgActionItem" [popup]="true" appendTo="body"></p-menu>
              <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
            </div>
          </td>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="loading">
        <tr>
          <td colspan="8" class="text-center">
            <p-progressSpinner></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="8"  class="no-data-record-found">
            <p>No records found</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  
  
  </div>
  
  <ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-orgnization-package
    (reload)="reload()" 
    [allPackages]="allPackages"
    [orgId]="orgId" (close)="displayAddModal= false"></app-create-orgnization-package>
  </p-dialog>
  </ng-container>

   <ng-container *ngIf="displayEditModel">
  <p-dialog [(visible)]="displayEditModel" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-orgnization-package
    (reload)="reload()" 
    [allPackages]="allPackages"
    [type]="'Update'"
    [orgDataToEdit]="orgDataToEdit"
    [orgId]="orgId" (close)="displayEditModel= false"></app-create-orgnization-package>
  </p-dialog>
  </ng-container>

<!--   
  
  
  <ng-container *ngIf="showEditOrgPackage">
    <p-dialog [(visible)]="showEditOrgPackage" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
      <app-create-campus 
      (reload)="reload()" 
      [orgId]="orgId" [type]="'Update'" [campusDataToEdit]="orgDataToEdit"
        (close)="showEditOrgPackage = false"></app-create-campus>
    </p-dialog>
  </ng-container>
  
  <ng-container *ngIf="showDeleteModal">
    <p-dialog [(visible)]="showDeleteModal" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
      <app-delete-campus
      [orgId]="orgId" 
      (reload)="reload()"
      [campusDataToEdit]="campusDataToEdit"
        (close)="showDeleteModal = false"></app-delete-campus>
    </p-dialog>
  </ng-container> -->